import TSlider from './slider.vue'

TSlider.install = Vue => {
  Vue.component(TSlider.name, TSlider)
}

export default TSlider



// WEBPACK FOOTER //
// ./src/module/slider/index.js